import { all } from 'redux-saga/effects'

import watchChangeStatus from './change-status'
import watchCreate from './create'
import watchDelete from './delete'
import watchGetDetail from './get-detail'
import watchGetList from './get-list'
import watchSync from './sync'
import watchUpdate from './update'

export default function* sagas() {
  yield all([
    watchGetList(),
    watchSync(),
    watchGetDetail(),
    watchUpdate(),
    watchCreate(),
    watchDelete(),
    watchChangeStatus(),
  ])
}
